// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SearchOutlinedSvg from "@fishx/icons-svg/es/asn/SearchOutlined";
import FishxIcon from '../components/FishxIcon';

var SearchOutlined = function SearchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SearchOutlinedSvg
  }));
};

SearchOutlined.displayName = 'SearchOutlined';
export default React.forwardRef(SearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SearchOutlined.js
// module id = 4078
// module chunks = 0